module.exports = __webpack_public_path__ + "83cd33073e1d86f5200702860e758469.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/qualcomm_2021_chart.png
// module id = 1713
// module chunks = 0